import styled from "styled-components";
import { COUPON_CODE_BADGE_BACKGROUND_URL } from "./constants";
import { getCloudinaryUrl } from "@swiggy-private/js-utils";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";

export const Wrapper = styled.div(({ theme }) => {
    return {
        width: "100%",
        display: "flex",
        alignItems: "center",
        overflow: "scroll",
        // hide scrollbar
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
        paddingBottom: theme.spacing.medium,
        paddingLeft: theme.spacing.medium,
    };
});

export const CouponCodePill = styled.div<{ applied?: boolean; isLast?: boolean }>(
    ({ theme, applied, isLast = false }) => {
        return {
            padding: `${theme.spacing.xSmall}`,
            borderRadius: theme.cornerRadius.small,
            // non standard DLS font as we need lower opacity for applied coupon code
            backgroundColor: applied ? "#DEFBEF" : theme.colors[theme.colorMode].border_Tertiary,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: `0 ${theme.spacing.xSmall} 0 ${theme.spacing.xSmall}`,
            marginRight: isLast ? theme.spacing.medium : theme.spacing.xSmall,
        };
    },
);

export const CouponCodeCounter = styled.span(() => {
    return {
        flex: "0 0 20px",
        width: "20px",
        height: "20px",
        backgroundImage: `url(${getCloudinaryUrl(COUPON_CODE_BADGE_BACKGROUND_URL)})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
    };
});

export const CounterText = styled(Text)(() => {
    return {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };
});

export const CouponCodeText = styled.div(({ theme }) => {
    return {
        marginLeft: theme.spacing.xxSmall,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        whiteSpace: "nowrap",
    };
});

export const PlusIconWrapper = styled.div(() => {
    return {
        width: "10px",
        height: "22px",
    };
});

export const TickIconWrapper = styled.div(() => {
    return {
        width: "16px",
        height: "16px",
    };
});

export const TickIcon = styled(SpriteIconWeb)(({ theme }) => {
    return {
        margin: `0 ${theme.spacing.xxSmall} 0 ${theme.spacing.xxSmall}`,
    };
});
